(function () {

    'use strict';

    angular.module('modernizr', [])
        .provider('modernizr', ModernizrProvider);

    ModernizrProvider.$inject = [
        '$windowProvider'
    ];
    function ModernizrProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.Modernizr || {};
            }
        };
    }
})();
